import { action, observable, makeObservable } from 'mobx';
import {logger} from '../../../helpers';
import {MovableState} from '../movable/models';
import {DraggableId} from '../models';
import {DragDropContextStore} from '../drag-drop-context/DragDropContextStore';
import {DroppableStore} from '../droppable/DroppableStore';
import {DraggableImpl} from './DraggableImpl';

let instanceIdCounter = 0;

export class DraggableStore {
  readonly instanceId: number;
  readonly draggableId: DraggableId;

  readonly context: DragDropContextStore;
  readonly parent: DroppableStore;

  @observable
  disposed: boolean;

  constructor(readonly component: DraggableImpl) {
    makeObservable(this);
    this.instanceId = instanceIdCounter++;
    this.draggableId = component.props.draggableId;
    this.parent = component.props.droppableStore;
    this.context = this.parent.contextStore;
    this.disposed = false;
  }

  @action
  mount() {
    this.parent.addDraggableStore(this);
  }

  @action
  onDragStart = (state: Readonly<MovableState>) => {
    logger.log('DraggableStore.onDragStart');
    this.context.onDragStart(this, this.parent, state);
  };

  @action
  onDragMove = (state: Readonly<MovableState>) => {
    logger.log('DraggableStore.onDragMove');
    this.context.onDragMove(this, this.parent, state);
  };

  @action
  onDragEnd = (state: Readonly<MovableState>) => {
    logger.log('DraggableStore.onDragEnd');
    this.context.onDragEnd(this, this.parent, state);
  };

  @action
  onDragCancel = (state: Readonly<MovableState>) => {
    logger.log('DraggableStore.onDragCancel');
    this.context.onDragCancel(this, this.parent, state);
  };

  @action
  dispose() {
    this.parent.removeDraggableStore(this);
    this.disposed = true;
  }
}
